<template>
  <b-row>
    <b-col md="12" class="mb-4">
      <h4 class="text-primary"><strong>Selected Activity</strong></h4>
      <div class="d-flex overflow-auto">
        <table size="sm" class="table table-sm">
          <thead>
            <tr class="text-truncate">
              <th style="width:5px" class="sticky-col text-center">#</th>
              <th style="width:5px" class="text-center">End Trip</th>
              <th style="min-width:200px" class="text-left">Fleet</th>
              <th style="min-width:200px">Start Date</th>
              <th style="min-width:200px">End Date</th>
              <th style="min-width:200px">Current Position</th>
              <th style="min-width:200px">Port Loading</th>
              <th style="min-width:200px">Port Discharge</th>
              <th style="min-width:200px">Agent POL</th>
              <th style="min-width:200px">Agent POD</th>
              <th style="min-width:200px">PIC / PE</th>
              <th style="min-width:200px">Departure</th>
              <th style="min-width:200px">Updated Today</th>
              <th style="min-width:200px">Reason</th>
              <!-- <th style="min-width:200px">Idle (Hours)</th> -->
              <th style="min-width:200px">Remarks</th>
              <th style="min-width:200px">Document on Board</th>
              <th style="min-width:200px" class="text-right">Cargo Loading</th>
              <th style="min-width:200px" class="text-right">Cargo Unloading</th>
            </tr>
          </thead>
          <tbody v-if="assign.length > 0">
            <tr class="text-truncate" v-for="(val, index) in assign" :key="index" style="min-width:200px">
              <td style="width:5px; cursor: pointer" class="sticky-col text-center" @click="assign.splice(index, 1)">
                <i class="fa fa-trash text-danger" />
              </td>
              <td class="text-center">
                <b-form-checkbox
                  v-if="val?.reason?.name === 'Unloading'"
                  name="check-button"
                  switch
                  inline
                  :checked="val.isEndTrip"
                  @change="setOnlyOneIsEndTrip(index)"
                >
                </b-form-checkbox>
              </td>
              <td class="text-truncate text-left">
                <div class="d-flex flex-column">
                  <span class="fs-5 mb-1" v-for="(v, v_index) in val.vehicle" :key="`h-v-${v_index}`">
                    <b-badge variant="success">{{ v?.name }}</b-badge>
                  </span>
                  <b-badge variant="primary" class="mb-1">{{formatString(val?.voyageType)}}</b-badge>
                </div> 
              </td>
              <td class="text-truncate">
                {{ val.startDate ? moment(val.startDate, 'DD-MM-YYYY HH:mm').format('DD MMM YYYY HH:mm'): '-'}}
              </td> 
              <td class="text-truncate">
                {{ val.endDate ? moment(val.endDate, 'DD-MM-YYYY HH:mm').format('DD MMM YYYY HH:mm'): '-'}}
              </td>  
              <td class="text-truncate">{{ val.currentPosition }}</td>
              <td class="text-truncate">{{ val.portLoading.portName }}</td>
              <td class="text-truncate">{{ val.portDischarge.portName }}</td>
              <td class="text-truncate">{{ val.agentPol }}</td>
              <td class="text-truncate">{{ val.agentPod }}</td>
              <td>
                <div class="d-flex flex-column">
                  <span class="fs-5 mb-1" v-for="(v, v_index) in val.pic" :key="`h-v-${v_index}`">
                    <b-badge variant="info">{{ v?.name }}</b-badge>
                  </span>
                </div>
              </td>
              <td class="text-truncate">
                {{ val.podDeparture ? moment(val.podDeparture, 'DD-MM-YYYY HH:mm').format('DD MMM YYYY HH:mm'): '-'}}
              </td>
              <td class="text-truncate">
                {{ moment().format('DD MMM YYYY HH:mm') }}
              </td>
              <td>{{ val?.reason?.name || '-'}}</td>
              <!-- <td>-</td> -->
              <td class="text-left">{{val.remark}}</td>
              <td class="text-truncate">
                {{ val.polDocOnBoard ? moment(val.polDocOnBoard, 'DD-MM-YYYY HH:mm').format('DD MMM YYYY HH:mm'): '-'}}
              </td>
              <td class="text-right">{{Number(val?.cargoLoading || 0)?.toLocaleString()}}</td>
              <td class="text-right">{{Number(val?.cargoUnloading || 0)?.toLocaleString()}}</td>
            </tr>
          </tbody>
          <tbody v-else>
            <tr>
              <th class="text-center" colspan="17">No Selected Activity List.</th>
            </tr>
          </tbody>
        </table>
      </div>
    </b-col>
    <b-col md="12">
      <h4 class="text-primary"><strong>Assign to Trip</strong></h4>
      <div class="d-flex overflow-auto">
        <table class="table">
          <thead>
            <tr class="text-truncate">
              <th class="sticky-col text-center">#</th>
              <th class="text-truncate" >Trip Info</th>
              <th>Start Date</th>
              <th>End Date</th>
              <th>Project</th>
              <th style="width:250px">POL Remark</th>
              <th style="width:250px">POD Remark</th>
            </tr>
          </thead>
          <tbody v-if="unfinishedTrip.length > 0">
            <tr v-for="(val, index) in unfinishedTrip" :key="index" class="cursor-pointer">
              <td class="sticky-col text-center">
                <b-form-checkbox
                  name="check-button"
                  switch
                  inline
                  v-model="val.checked"
                  @change="setChecked(index)"
                >
                </b-form-checkbox>
              </td>
              <td class="text-truncate">
                <div class="d-flex flex-column">
                  <div class="d-flex align-items-center text-primary">
                    <i class="fas fa-map-pin mr-2"></i>
                    {{val?.portLoading?.portName || val?.portLoadingOther}}
                  </div> 
                  <div class="dashed-border"></div>
                  <div class="d-flex align-items-center text-primary">
                    <i class="fa fa-map-pin mr-2"></i>
                    {{val?.portDischarge?.portName || val?.portDischargeOther}}
                  </div>
                </div>
              </td>
              <td class="text-truncate">
                {{ val.startDate ? moment(val.startDate, 'DD-MM-YYYY HH:mm').format('DD MMM YYYY HH:mm'): '-'}}
              </td> 
              <td class="text-truncate">
                {{ val.endDate ? moment(val.endDate, 'DD-MM-YYYY HH:mm').format('DD MMM YYYY HH:mm'): '-'}}
              </td>  
              <td class="text-truncate">{{ val.subProject.project.projectName }} - {{ val?.subProject?.name }}</td>
              <td class="text-left">{{ val.polRemark }}</td>
              <td class="text-left">{{ val.podRemark }}</td>
            </tr>
          </tbody>
          <tbody v-else>
            <tr>
              <th class="text-center" colspan="7">No Assign Trip List.</th>
            </tr>
          </tbody>
        </table>
      </div>
    </b-col>

    <b-col md="12" v-if="unfinishedTrip.length > 0 && assign.length > 0">
      <div class="d-flex align-items-center justify-content-end">
        <button
          type="button"
          class="btn btn-outline-primary btn-menu mr-2"
          @click="closeSidebar('assign-trip')"
        >
          Cancel & Close
        </button>

        <button
          type="button"
          class="btn btn-primary btn-menu"
          @click="onSaveAssignTrip"
        >
          Assign & Submit
        </button>
      </div>
    </b-col>
  </b-row>
</template>

<script>
import moment from 'moment'
import { voyagesActions } from '@src/Utils/helper'
import LoadingOverlayFullscreen from '@src/components/LoadingOverlayFullscreen.vue'

export default {
  name:'SlideFormAssignTrip',
  props:{
    refreshData:{
      type:Function,
      default:() => {}
    },    
    checkedHistory:{
      type:Array,
      default:() => []
    },   
    closeSidebar:{
      type:Function,
      default:() => {}
    },     
    unCheckAll:{
      type:Function,
      default:() => {}
    },  
  },
  components:{
    LoadingOverlayFullscreen
  },
  data(){
    return {
      unfinishedTrip: [],
      
      saving: false, 
      currentValidTime: null,
      errorTimeText: '',
      errorTimeIndex: null,
      errorValidation: false,

      tripId: null,
  
      projectOptions: [],
      "assign": [],

      selectedIds:[]
    }
  },
  async mounted() {
    await this.fetchUnfinishTrip()
  },
  watch:{
    checkedHistory: {
      async handler(newValue) {
        let unloadingFound = false;
        this.assign = []
        this.assign = newValue?.map((val) => {
          let isEndTrip = false;
          if (!unloadingFound && val?.reason?.name === 'Unloading') {
            isEndTrip = val.isEndTrip;
            unloadingFound = true;
          }
          return {
            ...val,
            isEndTrip
          };
        }).sort((a, b) => new Date(b.startDate) - new Date(a.startDate));

        await this.fetchUnfinishTrip()
      },
      deep: true,  // Ensures Vue detects changes inside the array
      immediate: true // Runs the watcher immediately
    }
  },
  methods: {
    ...voyagesActions,
    setOnlyOneIsEndTrip(selectedIndex) {
      this.assign = this.assign.map((item, index) => ({
        ...item,
        isEndTrip: index === selectedIndex
      }));
    },
    setChecked(selectedIndex) {
      this.unfinishedTrip = this.unfinishedTrip.map((item, index) => ({
        ...item,
        checked: index === selectedIndex ? true : false
      }));
    },
    resetForm(){
      this.tripId = null
    },
    formatString(str) {
      return str
        .replace(/_/g, " ") // Replace underscores with spaces
        .toLowerCase()       // Convert to lowercase
        .replace(/\b\w/g, char => char.toUpperCase()); // Capitalize first letter of each word
    },
    saveDraft(){
      localStorage.setItem('assign_trip', JSON.stringify(this.selectedIds));
      this.$swal('Saved.', 'Data Activity Saved.', 'success')
    },
    pasteDraft(){
      const savedData = localStorage.getItem('assign_trip');
      if (savedData) {
        let saved = JSON.parse(savedData);
        this.$swal('Paste.', 'Data Paste.', 'success')
      } else {
        this.$swal('Oops.', 'No data on draft.', 'warning')
      }
    },

    async fetchUnfinishTrip () {
      this.unfinishedTrip = []
      let params = {
        vehicleId: this.$route.query.vehicleId
      }

      const res = await this.getVoyageUnfinishedTrip(params)

      if (res.status == 'success') {
        let vehicle = []
        res.data.map(val => {
          vehicle = val.vehicle
          this.unfinishedTrip.push({
            ...val,
            checked: this.$route.query?.activityEditId ? true : false
          })
        })

        vehicle?.filter((el, i) => el.id !== Number(this.$route.query?.vehicleId))
      }
    },


    async onSaveAssignTrip(){
      let payload = this.assign?.map(val => {
        return {
          "voyageActivityId": val.id,
          "isEndTrip": val?.isEndTrip ? true : false
        }
      })

      let selectedTrip = this.unfinishedTrip.find(obj => obj.checked)
      if(!selectedTrip) return this.$swal(
        'Oops.',
        'Select Assign Trip first.',
        'warning'
      )

      this.saving = true

      const res = await this.assignToTrip({data: payload, id: selectedTrip?.id})

      if (res.status === 'success') {
        this.$swal('Assign Trip!', res.data.message, 'success')
        this.resetForm()
        this.refreshData()
        this.unCheckAll()
        this.closeSidebar('assign-trip')
      } else {
        if (res.data.message != null) {
          this.$swal('Error', res.data.message, 'error')
        } else {
          this.$swal(
            'Error',
            'Something wrong with the server. Please try again later.',
            'error'
          )
        }
      }

      this.saving = true
    }
  },
}
</script>

<style scoped>
.dashed-border {
  padding: 10px;
  border-left: 2px dashed black; /* Dashed left border */
  margin-left:3px
}
.sticky-col {
  position: sticky;
  left: 0;
  z-index: 2;
}
/* Column-specific left offsets */
.col-1 {
  left: 0;
  z-index: 3;
  min-width: 50px;
  max-width: 50px;
}
.col-2 {
  left: 50px; /* adjust this to match col-1 width */
  z-index: 3;
  min-width: 200px;
}
</style>